import { RouteProps } from '../../routes/AppRouter'
import { Detail as PatientsPGDDetail } from '../../features/patients/pgd/Detail'
import { Title } from 'components/common/Title'

export function Detail(props: RouteProps) {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <PatientsPGDDetail id={props.id} />
    </>
  )
}
